import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import { useHistory } from 'react-router';
import Button from '@material-ui/core/Button';
import { Grid } from '@material-ui/core';
import ItechAccordin from '../../../components/itechAccordin';
import './styles.css';
import { userType } from '../../../config/usertypeValue';

const useStyles = makeStyles({
    root: {
        boxShadow: '0px 5px 10px #efefef !important',
        borderRadius: '8px',
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },

    pos: {
        marginBottom: 12,
    },
    cardCustom: {
        padding: '0 !important',
    },
    fullWidth: {
        width: '100%',
        marginTop: '5%',
        position: 'fixed',
        left: '0',
        bottom: '0',
    },
});

export default function ItechCheckList(props) {
    const classes = useStyles();
    const [page, setPage] = useState(1);
    const bull = <span className={classes.bullet}>•</span>;
    const history = useHistory();
    const servicesID = useSelector((state) => state.serviceCheckListReducer.serviceIdSelected);

    const navigate = () => {
        props.history.push('/menu/addAdditional');
    };

    const subHeader = () => {
        return 'Service ID : ' + servicesID;
    };

    const navigateChecklist = (path, typeValue) => {
        // userType.value = typeValue;
        // history.push(path);
    };

    return (
        <div>
            <div className="stage-indicator">
                <ul>
                    <li onClick={() => navigateChecklist('menu/crc-checklist', 'L1 Checklist')} className="active">
                        L1 Checklist
                    </li>
                </ul>
            </div>
            <Card className={classes.root}>
                <CardContent className={classes.cardCustom}>
                    <CardHeader className="borderBottomLine title-padding" title="Checklist Generator" subheader={subHeader()} />

                    <ItechAccordin />
                </CardContent>
            </Card>
            <Grid item sm={12}>
                <div className="footer-button">
                    <ul>
                        <li>
                            <Button color="primary" className="txt-capitalize buttonnext" type="submit">
                                Save
                            </Button>
                        </li>
                        <li>
                            <Button color="primary" className="txt-capitalize buttonnext" type="submit">
                                Submit
                            </Button>
                        </li>
                    </ul>
                </div>
            </Grid>
        </div>
    );
}
